var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCruz(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 8.5,
    r: 8,
    stroke: "#47FFBD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.11412 6.11412C6.26628 5.96196 6.51298 5.96196 6.66513 6.11412L8.50001 7.949L10.3349 6.11412C10.487 5.96196 10.7337 5.96196 10.8859 6.11412C11.0381 6.26628 11.0381 6.51298 10.8859 6.66513L9.05103 8.50001L10.7571 10.2061C10.9092 10.3582 10.9092 10.6049 10.7571 10.7571C10.6049 10.9092 10.3582 10.9092 10.2061 10.7571L8.50001 9.05103L6.79396 10.7571C6.6418 10.9092 6.39511 10.9092 6.24295 10.7571C6.09079 10.6049 6.09079 10.3582 6.24295 10.2061L7.949 8.50001L6.11412 6.66513C5.96196 6.51298 5.96196 6.26628 6.11412 6.11412Z",
    fill: "#47FFBD"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCruz);
export default __webpack_public_path__ + "static/media/cruz.d4a7af9648087b085533f746fdff4402.svg";
export { ForwardRef as ReactComponent };